import { useBridgeReceiptUrl } from '~/components/txn-display/state-change/hooks/useBridgeReceiptUrl'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'
import { getExplorerTransactionLinkChainId } from '~/utils/addresses'
import { parseTransactionMetadata } from '~/utils/parseTransactionMetadata'

export const useShowBridgeFooter = (
  transaction: OrgRegularTransaction | PublicRegularTransaction,
) => {
  const bridgeReceiptUrl = useBridgeReceiptUrl(transaction)

  const transactionMetadata = parseTransactionMetadata(
    transaction.transactionMetadata,
  )

  if (!transactionMetadata.bridgeData) return false

  if (transactionMetadata.bridgeData.status === 'SUCCESS') {
    const explorerUrl = getExplorerTransactionLinkChainId(
      transactionMetadata.bridgeData.destinationTransaction?.hash,
      transactionMetadata.bridgeData.destinationChainId,
    )

    // if the explorer url is available, we don't need to show the footer
    // because the explorer url will be shown in the timeline
    if (explorerUrl) return false
  }

  if (transactionMetadata.bridgeData.status === 'FAILURE') {
    const explorerUrl = getExplorerTransactionLinkChainId(
      transactionMetadata.bridgeData.refundTransaction?.hash,
      transaction.chainId,
    )

    // if the explorer url is available, we don't need to show the footer
    // because the explorer url will be shown in the timeline
    if (explorerUrl) return false
  }

  // if the bridge status is not success or failure, we don't need to show the footer
  const showBridgeReceiptUrl = ['SUCCESS', 'FAILURE'].includes(
    transactionMetadata.bridgeData.status ?? '',
  )

  // if the bridge receipt url is available, we need to show the footer
  return showBridgeReceiptUrl && bridgeReceiptUrl
}
